import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import { makeSpine } from "html-living-framework/lib/Utils/PixiUtils";
import {Ease} from "../core/Animatable";
import {IPoint, PointUtil} from "../core/Geom";
import {Callback} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import {AbstractCharacter} from "./AbstractCharacter";
import {TrashItem} from "./TrashItem";
import { TrashItemCollect } from "./TrashItemCollect";
import { TrashItemReturn } from "./TrashItemReturn";

export class Grover extends AbstractCharacter {

    public readonly spine = this.addChild(makeSpine("grover-profile"));

    protected animations = {
        BLINK: "blink",
        IDLE: "idle-no-head-keys",
        LIP_FLAP: "lip-flap",
        WALK: "walk",
        WAVE: "wave",
        LOOK_LEFT: "intro-look-left",
        LOOK_RIGHT: "intro-look-right",
    };

    constructor() {
        super("grover");
    }

    public LookLeft() {
        this.spine.state.setAnimation(this.tracks.HEAD, this.animations.LOOK_LEFT, false);
    }

    public LookRight() {
        this.spine.state.setAnimation(this.tracks.HEAD, this.animations.LOOK_RIGHT, false);
    }

    public LookCenter() {
        this.spine.state.setEmptyAnimation(this.tracks.HEAD, 0.25);
    }

}
